<template>
    <div class="container" v-if="loaded && pubAgreement?.id">
        <div class="row">
            <div class="col-12">
                <PreviousNavLink :go-to-link="`/organisation/${orgId}`" previous-label="Tillbaka" />

                <div>
                    <h1 class="page-header">Överenskommelse och PUB-avtal</h1>

                    <p class="intro">
                        Överenskommelsen är ett avtal som möjliggör tecknade av PUB-avtal innan köp av licens.
                        Det innebär också att PUB-avtalet fortsätter gälla ifall licensen går ut innan den hinner förnyas.
                        <br /><br />
                        PUB-avtalet är liktydig med SKR:s mall och innehåller bilagorna 1. Instruktion och 2. Underbiträden.
                    </p>

                    <p v-if="status === 'Active' || status === 'Approved'" class="mb-4">
                        Båda avtal är bekräftade {{ formatDateToDateTime(signDate) }} av {{ signName }}
                    </p>
                </div>

                <PDFView :key="pubAgreement.id + '-pub'"
                         :path="`${baseUrl}/agreement/${pubAgreement.id}/GetPubAgreementPdf/`"
                         title="PUB-avtal" />

                <PDFView :key="pubAgreement.id + '-main'"
                         :path="`${baseUrl}/agreement/${pubAgreement.id}/GetAgreementPdf/`"
                         title="Överenskommelse" />

                <CtaPanel>
                    <div class="buttons-container spread-buttons">
                        <PreviousNavLink :go-to-link="`/organisation/${orgId}`" previous-label="Tillbaka" />

                        <router-link v-if="status === 'Inactive'"
                                     :to="`/organisation/${orgId}/avtal/intro`"
                                     class="btn btn-light">
                            Till undertecknande
                        </router-link>
                    </div>
                </CtaPanel>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, computed, onMounted } from "vue";
    import axios from "axios";
    import { useRoute } from "vue-router";
    import PreviousNavLink from "@/components/PreviousNavLink.vue";
    import PDFView from "@/components/PDFView.vue";
    import CtaPanel from "@/components/CtaPanel.vue";
    import { formatDateToDateTime } from "@/helper/dateFormat";

    export default defineComponent({
        name: "OrgAgreement",
        components: {
            PreviousNavLink,
            PDFView,
            CtaPanel
        },
        setup() {
            const baseUrl = import.meta.env.VITE_APP_URL;
            const route = useRoute();

            const orgId = route.params.orgId as string;

            const mode = route.params.mode as string | undefined;
            const isOld = mode === 'old';

            const pubAgreement = ref<any>(null);
            const loaded = ref(false);

            onMounted(async () => {
                let path = `${baseUrl}/agreement/${orgId}/pubagreements`;

                if (isOld) {
                    path += "?old=true";
                }

                const res = await axios.get(path);
                pubAgreement.value = res.data;

                loaded.value = true;
            });

            const status = computed(() => pubAgreement.value?.status);
            const signDate = computed(() => pubAgreement.value?.signedDateOrganisation);
            const signName = computed(() => pubAgreement.value?.signedBy);

            return {
                baseUrl,
                orgId,
                pubAgreement,
                loaded,
                status,
                signDate,
                signName,
                formatDateToDateTime
            };
        }
    });
</script>

<style scoped>
    .buttons-container {
        width: 100%;
        margin-left: 0;
    }
</style>